"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectItemsAdventureHandler = void 0;
const __1 = require("../..");
const enums_1 = require("../../core/enums");
const core_1 = require("../../core/events/core");
const EventType_1 = require("../../core/events/EventType");
const RoomArgs_1 = require("../../core/rooms/RoomArgs");
const RoomScript_1 = require("../../core/rooms/RoomScript");
const Schedule_1 = require("../../core/Schedule");
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
const Record_1 = require("../../utils/Record");
let CollectItemsAdventureHandler = class CollectItemsAdventureHandler {
    init(sequence, container, state) {
        container.registerEventHandler(state.id, EventType_1.EventType.RoomCleared, Schedule_1.Schedule.Unlimited, new __1.TriggerAdventureEventHandlerArgs());
        container.registerEventHandler(state.id, EventType_1.EventType.RoomFailed, Schedule_1.Schedule.Unlimited, new __1.TriggerAdventureEventHandlerArgs());
        state.meta.collectedItems = (0, Record_1.mkRecord)(state.args.itemsToCollect, item => item.name, () => 0);
        const options = (0, Random_1.randomElement)(state.args.rooms);
        const roomId = container.addRoom(sequence, this.mkRoom(options));
        container.dispatch(sequence, state.id, new __1.EnterRoomActionArgs(roomId));
        container.getRoom(roomId).actors
            .filter(actorId => container.getFaction(actorId) === enums_1.Faction.Enemy)
            .forEach(actorId => container.registerEventHandler(actorId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new __1.TriggerAdventureEventHandlerArgs()));
        container.emitEvent(sequence, 0, new core_1.AdventureMetaUpdatedEventArgs(state.meta));
    }
    handleEvent(sequence, container, state, e) {
        sequence = sequence.pushSequence("sequential");
        switch (e.args.__typeName) {
            case "Killed": {
                state.args.itemsToCollect
                    .filter(item => item.dropRate >= (0, Random_1.randomPercent)())
                    .forEach(item => {
                    state.meta.collectedItems[item.name] += 1;
                });
                container.emitEvent(sequence, 0, new core_1.AdventureMetaUpdatedEventArgs(state.meta));
                break;
            }
            case "RoomCleared": {
                if (state.args.itemsToCollect.every(item => state.meta.collectedItems[item.name] >= item.requiredQuantity)) {
                    container.completeAdventure(sequence);
                    return;
                }
                const options = (0, Random_1.randomElement)(state.args.rooms);
                const roomId = container.addRoom(sequence, this.mkRoom(options));
                container.dispatch(sequence, state.id, new __1.EnterRoomActionArgs(roomId));
                container.getRoom(roomId).actors
                    .filter(actorId => container.getFaction(actorId) === enums_1.Faction.Enemy)
                    .forEach(actorId => container.registerEventHandler(actorId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new __1.TriggerAdventureEventHandlerArgs()));
                break;
            }
            case "RoomFailed": {
                container.failAdventure(sequence);
                break;
            }
            default:
                break;
        }
    }
    tick(sequence, container, state) { }
    mkRoom(options) {
        const count = (0, Random_1.random)(options.minEnemies, options.maxEnemies);
        const actors = [
            ...options.toSpawn.slice(),
            ...Array(options.randomSpawns.length > 0 ? count : 0).fill(0).map(() => (0, Random_1.randomElement)(options.randomSpawns))
        ];
        const room = new RoomArgs_1.RoomArgs([
            new RoomScript_1.BoundRoomScript("OnEnter_SpawnActors", {
                actors
            })
        ], [], [
            new RoomScript_1.BoundRoomScript("OnTick_ClearRoom_WhenEnemiesDefeated", {}),
            new RoomScript_1.BoundRoomScript("OnTick_FailRoom_WhenAlliesDefeated", {}),
        ], options.background);
        return room;
    }
};
CollectItemsAdventureHandler = __decorate([
    Registries_1.AdventureHandlers.register("CollectItems")
], CollectItemsAdventureHandler);
exports.CollectItemsAdventureHandler = CollectItemsAdventureHandler;
